import React from 'react'
import Loginform from '../../Components/Login/Loginform'
import Mobile from '../../Components/Mobile'

function Login() {

  return (
    <>
      <div className='bg-signin-bg min-h-screen'>
        <div className='grid w-11/12 md:w-8/12 min-h-screen py-10 mx-auto place-items-center'>
          <Loginform />
        </div>
      </div>
    </>
  )
}

export default Login